export default __webpack_public_path__ + "static/media/footer.9a99b8d9.png";